import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import ShopTable from '../../components/admin/ShopTable'
import { useFilters } from '../../hooks/useFilters'
import { FILTER_TYPES } from '../../constants/filters'

const DisplayRetailers = () => {
  const { renderFilters, filters, renderPagination } = useFilters()

  const { data: retailersData } = useQuery({
    queryKey: QueryKeys.adminListRetailers(filters),
    queryFn: () => handleGetRequest(`/admin/retailers`, filters),
  })

  const retailers = retailersData?.data || []

  return (
    <>
      <div className="flex gap-6 mb-8">
        {renderFilters([
          FILTER_TYPES.search,
          FILTER_TYPES.isApproved,
          FILTER_TYPES.isActive,
          FILTER_TYPES.sort,
        ])}
      </div>
      <div className="border overflow-hidden w-full">
        <div className="overflow-x-auto">
          <ShopTable data={retailers} onView={(shopSlug) => `/admin/retailers/${shopSlug}`} />
        </div>
      </div>

      {renderPagination(retailersData?.meta)}
    </>
  )
}

export default DisplayRetailers
